<template>
<div ref="livetalk" class ="pop-livetalk" v-bind:class="{ active: isLivetalkActive }">
  <VideoHeader ref="videoHeader" :startTime="startTime" :endTime="endTime"/>
  <div class="pop-livetalk-cont">   
    <VideoForm  @onPlay="onPlay" :streamingUrl="streamingUrl" :isPause="videoPause" />
    <div class="notice-wrap">
      <div class="swiper-container" ref="swiperContainer">
        <ul class="swiper-wrapper">
          <li v-if="!isShowNotice" >
            <!-- <p :class="notice"  @click="showModal(productName)">{{productName}}</p> -->
            <a href="#" @click="showModal(productName)" >{{productName}}</a>     
          </li>
          <li v-else class="swiper-slide" v-for="(notice, index) in arrNotices" :key="index">
            <a :href="notice.link" :class="{ notice: notice.isNotice }" @click="showModal(notice.text)" >{{ notice.text }}</a>     
          </li>
        </ul>
      </div>
      <!-- <a :href=buyUrl id="buyBtn" class="btn-buy" v-if="showBuyUrl" target='_self' @click="clickBuyButton()">바로구매</a> -->
      <a href='#' id="buyBtn" class="btn-buy" v-if="showBuyUrl" @click="clickBuyButton()" aria-readonly="true">바로구매</a>
      <!-- <a href='#' id="buyBtn" class="btn-buy" v-if="showBuyUrl" @click="clickBuyButton()">바로구매</a> -->
    </div>
    <div class = "chat-box" ref="chatBox">
      
      <alertDlg v-if="showAlert" @close="showAlert = false">
        <h1 class="txtC" slot="header">알림</h1>
        <!-- <i class="fas fa-times closeModalBtn" @click="showAlert=false"></i> -->
        <div slot="body">
          <h2>{{alertMessage}}</h2>
        </div>
      </alertDlg>
      <div class="pop-nickname-field-dimmed" v-if="showAlert"></div>
      <!-- 진행 중인 방송이 없어 입장이 거부된 경우. 확인을 누르면 앱으로 돌아간다. -->
      <alertDlg v-if="noBroadcast" @close="leaveChatRoom()">
        <h1 class="txtC" slot="header">알림</h1>
        <div slot="body">
          <h2>{{noBroadcastReason}}</h2>
        </div>
      </alertDlg>
      <div class="pop-nickname-field-dimmed" v-if="noBroadcast"></div>
      <!-- 웰컴  -->
      <Transition name="display">
        <div class="message welcome" v-if="isMember && isWelcomeVisible">
  <div class="inner">
    <p><span class="nick">{{ userData.userName }}</span>님 &amp;tok 참여를 환영합니다.</p>
    <a href="#none" class="btn-setting" v-if="showChangeNick" @click="handleSettingClick">설정</a>
  </div>
</div>

      </Transition>
      
			<div class="message welcome" v-if="!isMember">
				<div class="inner"><span class="nick"></span>
					<p>환영합니다. 로그인 후 &amp;tok에 참여하세요.</p>
				</div>
			</div>
      <chat-list ref="chatList" @scroll="onChatScroll" :custNo="custNo" :maskedLength="nickNameMaskLength" :msgs="msgData"></chat-list>
    </div>
    <LoginForm v-if="inputPoput" :userName="userData.userName" @close-popup="closeInputPopup" @just-close="justCloseInputPopup"/>
    <div class="pop-nickname-field-dimmed" v-if="inputPoput"></div>
    <!--https://streamable.com/4426zx-->
   <!-- 공지사항 하단 모달 -->


   
  <div>
    <transition
      name="slide-fade"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <section
        v-if="isModalOpen"
        class="layer-livetalk-notice" :class="{ 'open': isModalOpen }"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <div class="layer-livetalk-notice-header">
          <h1>공지사항</h1>
          <button type="button" class="btn-close" @click="closeModal">닫기</button>
        </div>
        <div class="layer-livetalk-notice-cont" v-html="modalNoticeText"></div>
      </section>
    </transition>
    <div
      v-if="isModalOpen"
      class="layer-livetalk-notice-dimmed"
      @click="closeModal"
    ></div>
 
  </div>


  
    <!-- <div v-if="!isMember" class="chat_footer" ref="chatFooter">
    <b-button class="loginBtn" variant="outline-secondary" v-if="!isMember" @click="loginClick">home&shopping LOGIN</b-button>
    </div> -->
  </div>
  <div class="chat-write" ref="chatWrite" v-if="isMember">
        <chat-form ref="chatForm" v-if="!isBanned" :badWords="badWords" :isMember="isMember" :limitedLength="limitedLength" :limitedMsgCount="limitedMsgCount" @submitMessage="sendMessage"></chat-form>
  </div>
  <div class="chat-write disabled" ref="chatWrite"  v-else>
    <chat-form ref="chatForm"  v-if="!isBanned" :badWords="badWords" :isMember="isMember" :limitedLength="limitedLength" :limitedMsgCount="limitedMsgCount" @submitMessage="loginClick"></chat-form>
  </div>
</div>
<!-- <router-link tag="button" class="btn trn" to="/login">home&shopping LOGIN</router-link> -->
</template>

<script>
import { mapMutations, mapState } from "vuex";
import alertDlg from "@/components/alertDlg";
import VideoForm from "@/components/VideoForm";
import ChatList from "@/components/ChatList";
import ChatForm from "@/components/ChatForm";
import Constant from "@/Constant";
import CryptoJS from 'crypto-js';
import LoginForm from "@/components/LoginForm";
import VideoHeader from "@/components/VideoHeader.vue";
import '@/styles/style.css';
//import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import Swiper from 'swiper'; // Swiper 라이브러리를 임포트합니다.
import "swiper/css/swiper.css"; // Swiper 스타일을 임포트합니다.

export default {
  data() {
    return {
      userData:  { userName : ''},
      popupVal:false,
      popupMsg:'',
      streamingUrl:'',
      isBanned:false,
      bannedEndTime:'',   // 채팅금지가 풀리는 방송 종료시각(표시용)
      onairStartTime:'',  // 방송 전환 감지용
      inputPoput:false,
      showAlert:false,
      alertMessage:'',
      limitedLength:50,
      limitedMsgCount:10,
      nickNameMaskLength:3,
      badWords:[],
      videoPause:false,
      swiper: null,
      showChangeNick: true,
      //buyUrl: 'http://mp3.hnsmall.com/goods/view/25521824',
      buyUrl: 'http://m.hnsmall.com/goods/view/25521824',
      // viewSize:0,
      scrollInterval: null,
      scrollToBottomInterval: null,
      touchStartY: 0,
      touchEndY: 0,
      prevVisualViewport: window.visualViewport ? window.visualViewport.height : 0,
      arrNotices: [
         //{ text: '[이쌀이다] 23년 햅쌀 진품 경기미 특미 오늘 하루 특가 행사', link: 'javascript:', isNotice: false },
         //{ text: '상품상세에 10% 할인쿠폰이 혜택 업그레이드되었습니다.', link: 'javascript:', isNotice: true },
         //{ text: '공지사항입니다.', link: 'javascript:', isNotice: true }
      ],
      isModalOpen: false,
      selectedNoticeIndex: null,
      modalNotice :'',
      // 편성 정보를 받기 전에는 비워둔다. 예전 기본값은 이미 지난 시각이라
      // 접속 직후 잠깐 '방송종료' 가 표시됐다.
      startTime:'',
      endTime:'',
      showBuyUrl: true,
      isConnectedSocket: false,
      // 진행 중인 방송이 없어 서버가 입장을 거부한 상태
      noBroadcast: false,
      noBroadcastReason: '',
      isWelcomeVisible : false,
      isShowNotice:true,
      //buyPage: null,
      custNo:'',
      isNonUser: false,
      deviceId:'',
      isAtBottom :false,
      prevVisualViewport: 0
    }
  },
  components: {
    ChatList,
    ChatForm,
    VideoForm,
    alertDlg,
    LoginForm,
    VideoHeader,
    Swiper,
    //NoticeSwiper
    //SwiperSlide
  },

  props: ["isMember","productCode","productName"],

  computed: {
    
    ...mapState({
      msgData: (state) => state.socket.msgData,
    }),
    modalNoticeText(){
      // 줄바꿈 있는경우 html 태그로 바꿈
      return this.modalNotice.replaceAll(/(\n|\r\n)/g, "<br />")
    }
  },
  created() {
    this.productName = '[이쌀이다] 23년 햅쌀 진품 경기미 특미 오늘 하루 특가 행사'
    
    this.deviceId = localStorage.getItem('deviceId') || this.generateUniqueId();
    localStorage.setItem('deviceId', this.deviceId);
    
    this.$nextTick(() => {
      this.setScrollHeight();
    }),
    // 최소화 복구 이벤트 감지
    window.addEventListener('focus', this.handleRestore);
    window.addEventListener('resize', this.setScrollHeight);
    // window.visualViewport.addEventListener('resize', this.handleVisualViewportResize);
  },
  // watch: {
  //   arrNotices() {
  //     this.$nextTick(() => {
      
  //     });
  //   }
  // },
  updated(){
    this.$nextTick(() => {
      this.setScrollHeight();
    });
  },

  // directives: {
  //   focus: {
  //     inserted(el, binding) {
  //       el.addEventListener('focus', binding.value);
  //     },
  //     unbind(el, binding) {
  //       el.removeEventListener('focus', binding.value);
  //     }
  //   }
  // },
  mounted() {
    if (window.visualViewport) {
      // 초기 뷰포트 높이 저장
      this.prevVisualViewport = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', this.handleVisualViewportResize);
    }
    //window.addEventListener('popstate', this.handlePopState);
    this.initLivetalk(); // 컴포넌트가 마운트될 때 initLivetalk 함수 호출
    //document.addEventListener('keyup', this.handleKeyup);
    //window.addEventListener('resize', this.handleResize);
    if (!this.deviceId) {
        this.deviceId = localStorage.getItem('deviceId');
        localStorage.setItem('deviceId', this.deviceId);    
    }

    this.$socket.on("connect", ()=> {
      if(this.userData.userName && this.custNo) {
        // 대화명 있고 고객번호 있고
        this.joinChatRoom(this.userData.userName, this.custNo, this.deviceId)
        this.showChangeNick = false
      } else {
        this.showChangeNick = true
        const urlPa = new URLSearchParams(window.location.search)
        this.custNo = urlPa.get('cust-no')
        this.isNonUser = false
        if(this.custNo === null) {
          // 고객 번호가 없는 경우, 비회원임
          let tempUser = urlPa.get('nonUserYn')
          tempUser = this.decrypt(tempUser)
          // 비회원 본인인증 로그인 고객일경우
          if(tempUser == 'Y') {
            this.isNonUser = true
          } else {
            this.isNonUser = false
          }
          this.custNo = ''
          // // 파라미터가 없으면 게스트로
          this.userData = { userName : ''}
          this.isMember = false
          this.joinChatRoom('','',this.deviceId)
        } else if (this.$route.query.id === undefined) {
          // 유저 로그인상태, 고객번호는 있고, 닉네임 없는 경우
          this.custNo = this.decrypt(this.custNo)
          if(this.custNo.length == 12 && !isNaN(this.custNo)) {
            this.openInputPopup()
          } else {
            // 고객번호가 12자리 숫자가 아닌경우
            this.joinChatRoom('','', this.deviceId)
          }
        } else {
          this.custNo = this.decrypt(this.custNo)
          let userName = this.decrypt(this.$route.query.id)
          
          let isStoredId = this.$route.query.isStoredId
          if(isStoredId){
            this.showChangeNick = true
          }
          else{
            this.showChangeNick = false
          }

          if(this.checkUserName(userName)){
            this.openInputPopup()
          }
          else {
            this.userData =  { userName : userName};
            this.joinChatRoom(userName, this.custNo, this.deviceId)
          
            if(userName == '') {
              this.isMember = false;
            } else {
              this.isMember = true;
              this.hideWelcome();
            }
          }
          //this.makeToast()
      //}
        }
      }
    })
    this.$socket.on("chat", (data) => {
      this.pushMsgData(data);
    });
    this.$socket.on("notice", (data)=>{
      //this.openPopup(data)
      if(data =="" || data== null){
        //this.showNotice = false
        // const newNotice = {
        //       text : this.productName, 
        //       link: 'javascript:',
        //       isNotice: false
        // }
        // //this.arrNotices.push({text: data2[i], link: '#', isNotice: true})
        this.arrNotices.splice(0)
        // this.arrNotices.push(newNotice)
        this.isShowNotice = false;
      }
      else{       
        this.arrNotices.splice(0)
        for(let i=0;i<data.length;i++){
          const newNotice =
          {
              text : data[i], 
              link: 'javascript:',
              isNotice: true
          }
          //this.arrNotices.push({text: data2[i], link: '#', isNotice: true})
          this.arrNotices.push(newNotice)
        }
        //this.initLivetalk(); // 컴포넌트가 마운트될 때 initLivetalk 함수 호출
        this.isShowNotice = true
      }
      this.$nextTick(()=>{
          this.initSwiper();
      })
    })
    this.$socket.on("streamingUrl", (data)=>{
      this.streamingUrl =data
    })
    this.$socket.on("updateBuyUrl",(data)=>{
      //this.buyUrl = 'https://m.hnsmall.com/order/livetalk/direct/'+data
      //this.buyUrl = 'https://mp3.hnsmall.com/goods/view/'+data
      this.buyUrl = 'https://m.hnsmall.com/goods/view/'+data
    })
    this.$socket.on("oldChat",(data)=>{
      // 이전 채팅 불러올때 다 날리고 불러옴
      this.msgData.splice(0)
      for(let i=0;i<data.length;i++)
      {
        this.pushMsgData(data[i])
      }
      this.isAtBottom = true
    })
    this.$socket.on("onairTime",(data)=>{

      // 2. 필요한 데이터
      const now = new Date()
      const year = now.getFullYear(); // YYYY
      const month = now.getMonth() + 1; // MM
      const day = now.getDate();	// DD
      // 3. 포맷 정의 
      const formatDate1 = `${year}/${month}/${day}`; // ex) 2023-06-30
      this.endTime = `${formatDate1} ${data}`;

    })
    this.$socket.on("programInfo", (data) => {
      // 방송이 바뀌면 이전 방송의 채팅금지는 해제된다.(서버도 같은 시점에 목록을 비운다)
      if(this.isBanned && data.onairStartTime != this.onairStartTime) {
        this.isBanned = false
        this.bannedEndTime = ''
      }
      this.onairStartTime = data.onairStartTime
      this.productCode = data.productCode
      this.productName = data.productName
      //this.buyUrl = 'https://m.hnsmall.com/order/livetalk/direct/'+this.productCode
      //this.buyUrl = 'https://mp3.hnsmall.com/goods/view/'+this.productCode
      this.buyUrl = 'https://m.hnsmall.com/goods/view/'+this.productCode
      if(this.productCode == ""||this.productCode == null) {
        this.showBuyUrl = false
      } else {
        this.showBuyUrl = true
      }

      setTimeout(() => {
      //   console.log('testtimer')
         this.setScrollHeight();
      //   //window.addEventListener('resize', this.setScrollHeight);
       }, 400);
      
      let onairEndTime = data.onairEndTime;
      let onairStartTime = data.onairStartTime;
      // 2. 필요한 데이터
      const now = new Date()
      const year = now.getFullYear(); // YYYY
      const month = now.getMonth() + 1; // MM
      const day = now.getDate();	// DD
      // 3. 포맷 정의 
      const formatDate1 = `${year}/${month}/${day}`; // ex) 2023-06-30
      this.startTime =`${formatDate1} ${onairStartTime}`; 
      this.endTime = `${formatDate1} ${onairEndTime}`;
    })
    this.$socket.on("banUser", (data) => {
      // 시간제가 아니라 현재 방송이 끝날 때까지 유지된다.
      // 서버가 새로고침 후 재접속(join) 시에도 다시 보내주므로 우회되지 않는다.
      const wasBanned = this.isBanned
      this.isBanned = true
      this.bannedEndTime = (data && data.endTime) ? data.endTime : ''

      // 재접속으로 상태만 복원한 경우에는 알림을 다시 띄우지 않는다.
      if(!wasBanned) {
        this.alertMessage = this.bannedEndTime
          ? `관리자에 의해 채팅이 금지되었습니다. (${this.bannedEndTime} 방송 종료까지)`
          : '관리자에 의해 채팅이 금지되었습니다. 방송 종료까지 채팅할 수 없습니다.'
        this.showAlert = true
      }
    })
    this.$socket.on("unbanUser", () => {
      if(this.isBanned == false) return
      this.isBanned = false
      this.bannedEndTime = ''
      this.alertMessage = '채팅금지가 해제되었습니다.'
      this.showAlert = true
    })
    this.$socket.on("chatRejected", (data) => {
      // 서버가 채팅을 거절한 경우(채팅금지 / 비속어)
      this.alertMessage = (data && data.reason) ? data.reason : '메시지를 전송할 수 없습니다.'
      this.showAlert = true
    })
    this.$socket.on("updatechattingOptions", (data) => {
      // console.log(data)
      this.limitedLength = data.length
      this.limitedMsgCount = data.count
      this.nickNameMaskLength = data.nickNameMaskLength
      this.badWords = data.badWords
    })
    this.$socket.on("ManagerChat", (data) => {
      this.pushMsgData(data);
      //this.isAtBottom = true
    });
    this.$socket.on("closeRoom", (data) => {
      // 관리자가 방송을 종료했다. 서버 지시에 의한 유일한 자동 퇴장 경로다.
      // (방송 시간이 끝난 것만으로는 더 이상 나가지 않는다)
      console.log('closeRoom: ' + ((data && data.reason) ? data.reason : ''))
      this.$refs.videoHeader.leaveChat()
    })
    this.$socket.on("joinRejected", (data) => {
      // 서버가 방송 없음을 이유로 입장을 거부했다.
      // 소켓을 끊어 채팅·편성 이벤트가 안내 화면 뒤로 흘러들지 않게 한다.
      this.noBroadcastReason = (data && data.reason) ? data.reason : '현재 진행 중인 채팅방이 없습니다.'
      this.noBroadcast = true
      this.isConnectedSocket = false
      this.$disconnect()
    })
    this.$socket.on("disconnect",(data) => {
      console.log('client disconnected : '+data)
      this.isConnectedSocket = false;
    })
    //this.initSwiper()
    //this.setScrollHeight()
    // setInterval(() => this.heartBeat(), 1000)
  },
  handlePopState(){
    this.prevVisualViewport = window.visualViewport.height
  },
  beforeDestroy() {
    // mounted에서 등록한 소켓 리스너 해제(공유 소켓이라 해제하지 않으면 재마운트 시 중복 등록됨)
    const socketEvents = [
      "connect", "chat", "notice", "streamingUrl", "updateBuyUrl", "oldChat",
      "onairTime", "programInfo", "banUser", "unbanUser", "chatRejected",
      "updatechattingOptions", "ManagerChat", "disconnect", "joinRejected", "closeRoom"
    ];
    socketEvents.forEach((ev) => this.$socket.off(ev));

    //window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('focus', this.handleRestore);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleVisualViewportResize);
    }
    window.removeEventListener('resize', this.setScrollHeight);
    // window.removeEventListener('resize', this.handleResize);
    // 스크롤 이벤트 리스너를 등록
  },
  methods: {
    // handleResize() {
    //     var $pop = document.querySelector('.pop-nickname-field');
    //     $pop.style.top = (window.innerHeight - $pop.offsetHeight) * 0.5 + 'px';
    //     console.log($pop.style.top);
    // },
    handleVisualViewportResize() {
      this.scrollToBottom()
      
      // if (window.visualViewport) {
      //   this.$nextTick(() => {
      //     const inputElement = this.$refs.chatWrite;
      //     const viewportHeight = window.visualViewport.height;
      //     const inputHeight = inputElement.offsetHeight;

      //     // 키보드 위로 입력창 이동
      //     inputElement.style.position = "fixed";
      //     inputElement.style.bottom = `${viewportHeight - inputHeight}px`;
      //   });

      //   window.visualViewport.addEventListener("resize", this.onViewportResize);
      // }
    },
    onViewportResize() {
      // console.log('onResize')
      const inputElement = this.$refs.chatWrite;
      const viewportHeight = window.visualViewport.height;
      const inputHeight = inputElement.offsetHeight;

      // 키보드 상단에 위치하도록 다시 조정
      inputElement.style.bottom = `${viewportHeight - inputHeight}px`;
    },
    resetInputPosition() {
      const inputElement = this.$refs.input;
      inputElement.style.position = "";
      inputElement.style.bottom = "";

      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", this.onViewportResize);
      }
    },
    afterLeave() {
      document.body.classList.remove('is-bottom-modal');
    },
    beforeEnter(el) {
      el.style.transform = 'translateY(100%)';
      //el.style.opacity = 0;
    },
    enter(el) {
      el.offsetHeight; // 트리거 리플로우
      el.style.transition = 'transform 0.3s ease';
      el.style.transform = 'translateY(0)';
      //el.style.opacity = 1;
    },
    leave(el) {
      el.style.transition = 'transform 0.3s ease';
      el.style.transform = 'translateY(100%)';
      //el.style.opacity = 0;
    },
    handleTouchStart(event) {
      // 터치 시작 위치 저장
      this.touchStartY = event.touches[0].clientY;
    },
    handleTouchEnd(event) {
      // 터치 종료 위치 저장
      this.touchEndY = event.changedTouches[0].clientY;

      // 터치 방향 판별
      if (this.touchEndY > this.touchStartY + 50) {
        // 터치가 하단으로 진행된 경우
        this.closeModal();
      }
    },
    onChatScroll({ scrollTop, isAtBottom }) {
      // console.log('스크롤 위치:', scrollTop);
      if (isAtBottom) {
        // console.log('chat-list at bottom');
        this.isAtBottom = true;
      } else {
        this.isAtBottom = false;
      }
    },
    generateUniqueId() {
      return 'id-' + Math.random().toString(36)
    },
    heartBeat() {
      //console.log('heartBeat')
      //if(this.isConnectedSocket == true) return;
      // this.reconnectChatServer()
    },
    onPlay(){
      this.videoPause = false
    },
    handleSettingClick(event) {
      event.preventDefault(); // 링크의 기본 동작 방지
      this.inputPoput = true;
      //console.log(this.inputPoput);
    },
    handleSlideClick(event) {
      event.preventDefault(); // 기본 링크 동작을 방지
      const notice = this.arrNotices.find(n => n.text === event.target.textContent);
      if (notice) {
        this.showModal(notice.text);
      }
    },
    clickBuyButton(){
      this.$disconnect()
      this.videoPause = true
      this.isConnectedSocket = false;
      window.open(this.buyUrl, "_blank");
      this.reconnectChatServer()
    },
    showModal(notice) {
      this.isModalOpen = true;
      this.modalNotice = notice;
      document.body.classList.add('is-bottom-modal');
    },
    // makeToast(append = false) {
    //   // 토스트메시지 테스트용, 고객번호, 이름 잘 들어갔는지
    //   this.$bvToast.toast(`custNo:${this.custNo}, Name:${this.userData.userName}`, {
    //     title: '알림',
    //     toaster: 'b-toaster-top-center',
    //     autoHideDelay: 5000,
    //     appendToast: append
    //   })
    // },
    hideWelcome() {
      this.isWelcomeVisible = true;
      // 5초 후에 환영 메시지를 숨김 // 5초 ->2.5초로 수정
      setTimeout(() => {
        this.isWelcomeVisible = false;
      }, 2500);
    },
    reconnectChatServer() {
      // console.log('user' +this.userData.userName )
      // 진행 중인 방송이 없어 서버가 입장을 거부한 상태면 다시 붙지 않는다.
      // 붙어봐야 또 거부당하고, 그때마다 안내 팝업과 disconnect 로그가 반복된다.
      // (창 포커스 복귀 때마다 handleRestore 가 이 함수를 부른다)
      if(this.noBroadcast) return;
      if(this.isConnectedSocket == false && !this.inputPoput ) {
        if(this.userData.userName){
          this.isMember = true;
        }
        this.$connect();
        this.msgData.splice(0)
        // console.log('reconnectChatServer')
        //this.joinChatRoom(this.userData.userName, this.custNo)
      }
    },
    async handleRestore() {
      if(this.isConnectedSocket == true) return;
      await new Promise(resolve => setTimeout(resolve, 500));
      this.reconnectChatServer()
    },
    closeModal() {
      this.isModalOpen = false;
      document.body.classList.remove('is-bottom-modal');
    },
    // openPopNickname() {
    //   // 팝업 엘리먼트와 입력 필드 엘리먼트 찾기
    //   let $pop = document.querySelector('.pop-nickname-field');
    //   let $input = document.querySelector('.pop-nickname-field .inp-filed input');
    
    //   // 팝업 열기
    //   $pop.classList.add('open');
    
    //   // 입력 필드에 포커스 설정
    //   $input.focus();
    
    //   // 입력 필드의 값 저장
    //   let val = $input.value;
    
    //   // 입력 필드의 값 초기화
    //   $input.value = '';
    
    //   // 이전 값으로 입력 필드 값 설정
    //   $input.value = val;
    
    //   // 팝업을 화면 중앙에 위치시키기
    //   $pop.style.top = (window.innerHeight - $pop.offsetHeight) * 0.5 + 'px';
    
    //   // body 요소에 클래스 추가
    //   document.body.classList.add('is-bottom-modal');
    // },
    ...mapMutations({
      pushMsgData: Constant.PUSH_MSG_DATA,
    }),
    
    initLivetalk() {
      // 바닥스크롤 막기
      document.documentElement.classList.add('not-scroll');
        // 스크롤 이벤트 리스너를 등록
      // 라이브톡 레이어 노출
      this.isLivetalkActive = true;
      // 채팅 메시지 영역 스크롤 높이 설정
  
      // 공지사항 롤링
      //this.initNoticeRolling();
    },
    // handleVisualViewportResize() {
    //   this.scrollToBottom()
    // },
   
    scrollToBottom() {
      //this.$nextTick(() => {
        //const container = this.$refs.livetalk;
        //container.scrollTop = container.scrollHeight;
        //console.log(container.scrollTop)

        const currentVisualViewport = window.visualViewport.height
        //console.log('pre' + this.prevVisualViewport  + 'cur'+ currentVisualViewport)
       
        if ( this.prevVisualViewport - 30 > currentVisualViewport &&
          this.prevVisualViewport - 100 < currentVisualViewport) {
          const scrollHeight = window.document.scrollingElement.scrollHeight
          const scrollTop = scrollHeight - window.visualViewport.height

          window.scrollTo(0, scrollTop) // 입력창이 키보드에 가려지지 않도록 조절
          //console.log('scroll top'+scrollTop)
          this.prevVisualViewport = window.visualViewport.height
        }
        if (currentVisualViewport +50 < this.prevVisualViewport ||
        currentVisualViewport > this.prevVisualViewport) {
          //console.log("Keyboard is visible via VisualViewport");
          // 키보드가 올라왔을 때의 로직
          this.prevVisualViewport = currentVisualViewport
        } 
    },
    // chat box 높이 구하기
    setScrollHeight() {
      this.$nextTick(() => {
        let chatBox = this.$refs.chatBox;
        const chatWrite = this.$refs.chatWrite;
        if (chatWrite && chatBox) {
          const chatboxHeight = chatWrite.getBoundingClientRect().top - chatBox.getBoundingClientRect().top;
          // if(chatboxHeight == this.viewSize){
          //   return;
          // }
          // this.viewSize = chatboxHeight; 
          chatBox.style.height = `${chatboxHeight}px`;

          // 채팅 메시지 영역 스크롤 최하단으로
          let chatScroll = chatBox.querySelector('.scroll');
          if (chatScroll) {
            if(this.isAtBottom){
              // 스크롤이 최하단일경우에만 
              chatScroll.scrollTop = chatScroll.scrollHeight;
            }
          }
        }
      });
      // if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      //   //this.isKeyboardOpen = true;
      //   document.body.style.paddingBottom = '300px';
      // } else {
      //   //this.isKeyboardOpen = false;
      //   document.body.style.paddingBottom = '0px';
      // }

    },
    
    // 공지사항 스와이퍼 초기화
    initSwiper() {
      const swiperContainer = this.$refs.swiperContainer;

      if (this.swiper) {
        //console.log('destroyed swiper')
        this.swiper.destroy();
      }

      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1, // 한 번에 하나의 슬라이드만 표시
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
          },
        loop: true,
        direction: 'vertical'
      });

      // Swiper의 슬라이드 변경 이벤트에 이벤트 핸들러를 설정합니다.
      this.swiper.on('slideChange', () => {
        const slides = swiperContainer.querySelectorAll('.swiper-slide');

        slides.forEach(slide => {
          const anchor = slide.querySelector('a');
          if (anchor) {
            anchor.removeEventListener('click', this.handleSlideClick); // 기존 이벤트 핸들러 제거
            anchor.addEventListener('click', this.handleSlideClick); // 새로운 이벤트 핸들러 추가
          }
        });
      });

      // 초기 슬라이드에 이벤트 핸들러를 설정합니다.
      const initialSlides = swiperContainer.querySelectorAll('.swiper-slide');
      initialSlides.forEach(slide => {
        const anchor = slide.querySelector('a');
        if (anchor) {
          anchor.addEventListener('click', this.handleSlideClick);
        }
      });
    },
    // 채팅방을 닫고 앱으로 돌아간다. 사용자가 확인을 눌렀을 때만 호출한다.
    // 안내는 내리지 않는다. 앱에서는 아래 호출로 창이 닫히고,
    // URL 스킴이 동작하지 않는 환경에서는 빈 채팅방을 보여주는 것보다 안내가 남는 편이 낫다.
    leaveChatRoom() {
      this.$refs.videoHeader.leaveChat()
    },
    // timerStop 은 시간제 채팅금지의 자동해제용이었다.
    // 방송단위 금지로 바뀌면서 서버의 unbanUser / programInfo 로 해제되므로 제거했다.
    joinChatRoom(userName, custNo, deviceId) {
        this.$join({
          name: userName,
          custNo: custNo,
          deviceId: deviceId
        });
        this.isConnectedSocket = true;
        this.$refs.videoHeader.startOnairTimer()
    },
    decrypt(text) {
      const encKey = "Q3BHEBp8Z2bQ8vxw";
      try {
        if(text) {
          const decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(encKey), {
            iv: CryptoJS.enc.Utf8.parse(encKey), // [Enter IV (Optional) 지정 방식]
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC // [cbc 모드 선택]);
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
        }
        else {
          return ''
        }

      } catch (error) {
        console.error('Decryption error:', error)
        console.log('Decryption failed')
        return ''
      }
    },
    loginClick() {
      // home&shopping login api
      // 로그인 성공시. 닉네임있을때, 없을때
      //console.log("Redirect hns login page:"+"https://m.hnsmall.com/customer/login?return_url=hns.atum.live" )
      //window.open("https://m.hnsmall.com/customer/login?return_url=hns.atum.live/chat", "_self");
      if(this.isNonUser){
        // 비회원 본인인증 로그인 고객일 경우 알림창으로 대체
        this.alertMessage = `비회원 인증 고객님은 서비스 이용이 불가능합니다. 회원 로그인 후 이용해주세요.`
        this.showAlert = true
      }
      else{
        this.$router.push({path:'login'})
      }
      
      //window.open("https://m.hnsmall.com/customer/login?return_url=10.10.1.209:4302/chat", "_self");
    },
    openInputPopup(){
      this.inputPoput = true;
    },
    justCloseInputPopup(){
      this.inputPoput = false;
    },
    closeInputPopup(data){
      const userName = data.trim()
      if(userName != "" && this.isConnectedSocket == false && this.custNo) {
        this.userData =  { userName : userName};
        this.isMember = true;
        this.joinChatRoom(userName, this.custNo, this.deviceId)
        // this.$join({
        //   name: userName,
        //   msg: '',
        //   custNo: this.custNo
        // });
        // this.isConnectedSocket = true;
      } else if(userName != "" && this.isConnectedSocket == true) {
        this.userData =  { userName : userName};
        this.isMember = true;
        this.$changeName({
          name: userName,
          custNo: this.custNo
        });
      }
            //5초 후 웰컴 코멘트 소멸
      this.hideWelcome();
      this.inputPoput = false;
      // this.makeToast()
    },
    openPopup(popupMsg){
      this.popupVal = true;
      this.popupMsg = popupMsg;
    },
    closePopup(){
      this.popupVal = false;
    },

    joinsumit(username) {
      const userData = {
        userName: username,
      };
      if (userData.userName) {
        this.$store.dispatch("login", userData);
      }
    },
    checkUserName(userName){
         const emojiRegex = /(?:[#*0-9]\uFE0F?\u20E3|[\u203C\u2049\u2139\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25FB\u25FC\u25FE\u2600-\u2604\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u265F\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2\uDED0-\uDED9\uDEE0-\uDEE7]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?))/g
      return emojiRegex.test(userName);
    },
    sendMessage(msg) {
      this.pushMsgData({
        name: this.userData.userName,
        admin: false,
        custNo: this.custNo,
        msg,
      });
      this.isAtBottom = true
      this.$sendMessage({
        name: this.userData.userName,
        custNo: this.custNo,
        msg,
      });
    },
  },
};
</script>

<style scoped>
.pop-nickname-field-dimmed
{z-index:5001; position:fixed;top:0;left:0;width:100%;height:100%;background-color: rgba(0,0,0,.5);font-size:0;}
.loginBtn{
  width: 100%;
  position: fixed;
  bottom: 15px; /* 원하는 여백 조절 */
}

.notice{
  padding-left: 10px;
}
/* .display-enter-active,
.display-leave-active {
  transition: opacity 3s ease-in-out; 
}

.display-enter-from,
.display-leave-to {
  opacity: 0; 
} */
</style>
